import { useEffect, useState } from 'react';
import { fetchPublicModule } from '../services/contentApi';

function useRemoteModule(moduleName, mapItem, fallbackItems) {
    const [items, setItems] = useState(fallbackItems || []);

    useEffect(() => {
        let cancelled = false;

        const load = async () => {
            try {
                const remoteItems = await fetchPublicModule(moduleName);
                if (!cancelled && remoteItems.length > 0) {
                    const mapped = remoteItems.map((item, index) => mapItem(item, index));
                    setItems(mapped);
                }
            } catch {
                if (!cancelled) {
                    setItems(fallbackItems || []);
                }
            }
        };

        load();

        return () => {
            cancelled = true;
        };
    }, [moduleName, mapItem, fallbackItems]);

    return items;
}

export default useRemoteModule;
